import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewTipoProveedor = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'tipo_proveedor',
        name: 'Tipo Proveedor',
        component: ViewTipoProveedor,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
